<p-blockUI [blocked]="loading" />
<div id="commercial-outage-action-buttons">
  <div class="buttons">
    <button
      pButton
      class="refresh-button"
      icon="fa fa-fw fa-refresh"
      aria-label="{{ 'COMMON.LABEL.BUTTONS.REFRESH' | translate }}"
      (click)="refresh()"
    ></button>
    <button
      pButton
      label="{{ 'COMMON.LABEL.BUTTONS.CLEAR' | translate }}"
      icon="fa fa-fw fa-eraser"
      (click)="clearScreen()"
    ></button>
  </div>
</div>

<app-progress-spinner [enabled]="loading && elements.length === 0" />
<div [style.display]="loading && elements.length === 0 ? 'none' : ''">
  <app-general-grid
    #grid
    [values]="elements"
    [columns]="columns"
    [loading]="loading"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [filterable]="true"
    [screenName]="screenName"
    [lazy]="true"
    (lazyLoad)="lazyLoad($event)"
    [includeExportCSV]="false"
    [scrollHeight]="scrollHeight"
    [usePaginator]="true"
    [rowsPerPageOptions]="[50, 100, 200]"
  />
</div>
